import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import SectionHeader from '../SectionHeader';
import SelectionList from '../SelectionList';
import { LANGUAGE } from '../../../../../constants/shared/CommonConstants';
import { TITLE, SECTION_MAPPER, SECTIONS } from '../../../../../constants/shared/RubricConstants';
import { getScoreLabel } from '../../../../../utils/shared/trcUtils';
import { generateReactKey } from '../../../../../utils/shared/commonUtils';

const { ENGLISH } = LANGUAGE;

const LanguageWritingGrammarSpelling = ({ rubrics, language }) => (
    <div className="language-writing-spelling-grammar comprehension-paragraphs">
        {rubrics.map(({ name, totalScore, totalMaxScore, itemLevelDetails }) => (
            <section key={generateReactKey(name)} className="rubric section-block">
                <SectionHeader
                    titles={[
                        get(TITLE, `${name}.${language}`),
                        getScoreLabel(totalScore, totalMaxScore),
                    ]}
                />
                {SECTIONS[name].map(section => {
                    const { score: studentScore } = itemLevelDetails[section];
                    const title = get(SECTION_MAPPER, `${section}.title.${language}`);
                    const scoresDescription = get(
                        SECTION_MAPPER,
                        `${section}.scoresDescription.${language}`,
                        [],
                    );
                    return (
                        <section key={generateReactKey(section)} className="sub-section">
                            <span className="title">{title}</span>
                            <SelectionList list={scoresDescription} resultScore={studentScore} />
                        </section>
                    );
                })}
            </section>
        ))}
    </div>
);

LanguageWritingGrammarSpelling.defaultProps = {
    rubrics: [],
    language: ENGLISH,
};

LanguageWritingGrammarSpelling.propTypes = {
    rubrics: PropTypes.array,
    language: PropTypes.string,
};

export default LanguageWritingGrammarSpelling;
